goog.provide("shadow.js.shim.module$react_use$lib$useBeforeUnload$default");
shadow.js.shim.module$react_use$lib$useBeforeUnload$default = shadow.js.shim.module$react_use$lib$useBeforeUnload.default;
